import script from "./ElementInfo.vue?vue&type=script&lang=js"
export * from "./ElementInfo.vue?vue&type=script&lang=js"

import "./ElementInfo.vue?vue&type=style&index=0&id=0c6b8b5c&lang=scss"

const __exports__ = script;

export default __exports__